import React from 'react';
import './newsContent.css';
import { setChartTitle } from '../../redux/slices/uiSlice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export default function NewsContent({ data }) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setChartTitle(null));
  }, [dispatch]);

  if (!data) return null;

  const { title, date, text, url } = data;

  return (
    <div className="news-detail">
      {/* Título */}
      <h1 className="news-title">{title}</h1>

      {/* Fecha */}
      <p className="news-date">
        {new Date(date).toLocaleDateString('es-ES', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })}
      </p>

      {/* Texto completo */}
      <div className="news-text">
        {text ? (
          text.split('\n').map((para, idx) => <p key={idx}>{para}</p>)
        ) : (
          <p>There is no content available for this news item.</p>
        )}
      </div>
      {/* Enlace original */}
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="news-link"
      >
        See original source →
      </a>
    </div>
  );
}
